<template>
  <div class="smsVerificationWrapper text-center">
    <p class="title">{{ $t('Confirmation code') }}</p>
    <div class="inputWrapper mt-4">
      <ValidationObserver ref="codeInput" id="codeInput">
        <ValidationProvider tag="div" name="code" rules="required" v-slot="{ errors }">
          <v-otp-input
            v-model="code"
            inputClasses="otp-input"
            :numInputs="4"
            separator="-"
            :shouldAutoFocus="true"
            @on-complete="handleOnComplete"
            @on-change="handleOnChange"
          />
          <div class="validation-error" v-if="errors.length">{{ errors[0] }}</div>
        </ValidationProvider>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: "sms-receiving",
  components: {
    // textInput
  },
  props: {
    authUrl: String,
    onSuccess: {
      type: Object
    },
    inputStyles:{
      type:Object,
      required:false,
      default:()=>{}
    }
  },
  data () {
    return {
      code: ""
    };
  },
  methods: {
    async verify () {
      const isValid = await this.$refs.codeInput.validate();
      if (!isValid) {
        this.scrollTo(`[id=codeInput`);
        this.$eventHub.$emit("done-event-trigger", {
          parent: this,
          status: false
        });
      }

      const formData = {
        mobile: `+${this.countryCode}${this.tel}`,
        code: this.code
      };
      const apiUrl = this.authUrl;
      this.$store.dispatch("verifyCode", { formData, apiUrl }).then(r => {
        if (r.response) {
          const fn = this.onSuccess.fn;
          const params = this.onSuccess.params;
          this[fn](params, this);
        } else {
          this.showModal(this.$t('The sms code is incorrect.'))
        }
      });
    },
    handleOnComplete (value) {
      this.code = value;
      console.log("OTP: ", value);
    },
    handleOnChange (value) {
      this.code = value;
      console.log("OTP: ", value);
    }
  },
  computed: {
    ...mapGetters(['countryCode', 'tel'])
  },
  mounted () {
    this.$eventHub.$on('verifySms-event', this.verify)
  },
  beforeDestroy () {
    this.$eventHub.$off('verifySms-event', this.verify)
  }
};
</script>
<style lang="scss" scoped>
.smsVerificationWrapper {
  font-family: inherit;
  max-width: 1440px;
  .description {
    font-size: 14px;
    &.bigger {
      font-size: 16px;
      font-weight: 400;
    }
  }
}

.title {
  text-align: left;
  font-weight: bold;
  color: var(--text-color-4);
}

.inputWrapper {
  display: flex;
  justify-content: center;
  .countryCode {
    font-size: 10px;
    width: 120px !important;
  }
  .phoneNumber {
    min-width: 185px;
  }
  .verificationCode {
    width: 200px;
  }
}

/deep/ .otp-input {
  width: 80px;
  height: 80px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  @media (max-width: 767px) {
    width: 40px;
    height: 40px;
  }
  @media (max-width: 400px) {
    width: 30px;
    height: 30px;
  }
}
.error {
  border: 1px solid red !important;
}

/deep/ .IZ-select {
  justify-content: center;
  width: 100%;
  border-radius: 100px;
  .validation-error {
    margin-left: 0;
  }

  .IZ-select__input {
    border: none;
    box-shadow: none;
    width: 100px;
    padding-left: 0;
  }

  .IZ-select__menu {
    width: 200px !important;
  }

  .IZ-select__input--selection-slot {
    & > div {
      flex: 1 1 auto;
    }
  }

  input {
    display: none;

    &.custom-input {
      display: block;
    }
  }
}

/deep/ .hide .IZ-select__menu {
  clip-path: polygon(0px 0px, 0px 0px, 0px 0px, 0px 0px);
}

</style>
